import React from 'react';
import { Link } from 'react-router-dom';

const MovieCard = ({ item }) => {
  const getPosterCard = (posterpath) => {
    return `https://image.tmdb.org/t/p/w500/${posterpath}`;
  };
  return (
    <Link to={`/movie/${item.id}`}>
      <div
        style={{
          backgroundImage: `url(${getPosterCard(item.poster_path)})`,
        }}
        className="relative bg-top bg-no-repeat bg-cover rounded-2xl mb-4 pt-72 lg:scale-95 hover:lg:scale-100 duration-300"
      ></div>
      <h1 className="text-xs md:text-base font-bold lg:text-lg">
        {item.title}
      </h1>
    </Link>
  );
};

export default MovieCard;
